import React from 'react';
import Link from 'next/link';
import { ChevronRightIcon } from '@heroicons/react/20/solid';

const Breadcrumbs = (props) => {
  const { breadcrumbs, ...restProps } = props;
  return (
    <div
      className="flex flex-row gap-x-1 text-sm font-medium text-[#111928]"
      {...restProps}
    >
      {breadcrumbs.map((breadcrumb, idx, arr) => {
        return (
          <div key={breadcrumb.name} className="flex items-center">
            {breadcrumb.href ? (
              <Link prefetch={false} href={breadcrumb.href}>
                {' '}
                {breadcrumb.name}
              </Link>
            ) : (
              <p>{breadcrumb.name}</p>
            )}

            {idx < arr.length - 1 && <ChevronRightIcon className="h-5 w-5" />}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
